<div class="category-nav-container row clearfix" [class.is-rtl]="isRtl">
    <div class="col-xs-6">
        @if (categoryPrev) {
            <a class="is-flex align-middle" [href]="categoryPrev.locationPath" (click)="goToPrev($event)">
                <div class="arrow-container arrow-left text-center">
                    <md-icon name="arrow-back"></md-icon>
                </div>

                <div class="section-nav-container has-ellipsis">
                    <p class="title-s ttu">{{ categoryPrev.name }}</p>
                    <p class="text-l">{{ categoryPrev.parentName }}</p>
                </div>
            </a>
        }
    </div>

    <div class="col-xs-6">
        @if (categoryNext) {
            <a class="is-flex align-middle" [href]="categoryNext.locationPath" (click)="goToNext($event)">
                <div class="section-nav-container has-ellipsis text-right">
                    <p class="title-s ttu">{{ categoryNext.name }}</p>
                    <p class="text-l">{{ categoryNext.parentName }}</p>
                </div>
                <div class="arrow-container text-center">
                    <md-icon name="arrow-right"></md-icon>
                </div>
            </a>
        }
    </div>
</div>
